import { Card, CardContent, CardHeader, CardTitle } from '../ui/card';
import { Container } from '../layout/container';
import { SectionHeading } from './section-heading';
import type { SiteContent } from '../../content/types';

interface BenefitsSectionProps {
  content: SiteContent;
}

export function BenefitsSection({ content }: BenefitsSectionProps): JSX.Element {
  return (
    <section className="py-12 sm:py-16">
      <Container className="space-y-8">
        <SectionHeading title={content.whyUsSection.headline} />
        <div className="grid gap-4 md:grid-cols-2">
          {content.whyUsSection.items.map((item) => (
            <Card key={item.title} className="h-full bg-white">
              <CardHeader className="pb-3">
                <CardTitle className="text-base">{item.title}</CardTitle>
              </CardHeader>
              <CardContent>
                <p className="text-sm text-[color:var(--color-muted)]">{item.text}</p>
              </CardContent>
            </Card>
          ))}
        </div>
      </Container>
    </section>
  );
}
